import * as yup from "yup";

declare module "yup" {
   export interface StringSchema {
      /**
       * Check for full name validity.
       *       
       * @param {Boolean} [required=false] Is fullname required.
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      fullName(
         required: boolean,
         errorMessage?: string
      ): StringSchema;
   }
}
const YUP_FULL_NAME_METHOD = "fullName";
yup.addMethod(yup.string, YUP_FULL_NAME_METHOD, function yupFullName(
   required: boolean,
   errorMessage = ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "Full name is required.";

   return this.test(YUP_FULL_NAME_METHOD, errMsg, (value: string) => {
      if (!value)
         return !required;
      else
         return value.split(" ").filter(function (s) { return !!s; }).length > 1;
   });
});
